import { Suspense } from "react"
import { Navigate, Route, Routes } from "react-router"
import { AdminShell } from "./components/AdminShell"
import { AuthPageLoader } from "./components/AuthPageLoader"
import { RequireAuth } from "./lib/auth"
import {
  Login,
  MiniApp,
  Setup,
  ForgotPassword,
  ResetPassword,
  SetupPassword,
  Dashboard,
  Reports,
  Orders,
  OrderDetail,
  Customers,
  CustomerDetail,
  OrderEditor,
  Jobs,
  Issues,
  IssueDetail,
  SalesPoints,
  SalesPointDetail,
  Channels,
  TelegramBots,
  Nomenclature,
  NomenclatureDetail,
  SyncRuns,
  Users,
  DocumentCreate,
  DocumentHistory,
  DocumentHistoryDetail,
  StoreMappings,
  ReferenceData,
  ApiTokens,
  CatalogValidation,
} from "./pages/lazy"

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Suspense fallback={<AuthPageLoader />}><Login /></Suspense>} />
      <Route path="/miniapp" element={<Suspense fallback={<AuthPageLoader />}><MiniApp /></Suspense>} />
      <Route path="/setup" element={<Suspense fallback={<AuthPageLoader />}><Setup /></Suspense>} />
      <Route path="/forgot-password" element={<Suspense fallback={<AuthPageLoader />}><ForgotPassword /></Suspense>} />
      <Route path="/reset-password" element={<Suspense fallback={<AuthPageLoader />}><ResetPassword /></Suspense>} />
      <Route path="/setup-password" element={<Suspense fallback={<AuthPageLoader />}><SetupPassword /></Suspense>} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <AdminShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="admin">
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="reports" element={<Reports />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/new" element={<OrderEditor />} />
          <Route path="orders/:id" element={<OrderDetail />} />
          <Route path="orders/:id/edit" element={<OrderEditor />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/:key" element={<CustomerDetail />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="issues" element={<Issues />} />
          <Route path="issues/:id" element={<IssueDetail />} />
          <Route path="sales-points" element={<SalesPoints />} />
          <Route path="sales-points/:id" element={<SalesPointDetail />} />
          <Route path="channels" element={<Channels />} />
          <Route path="telegram-bots" element={<TelegramBots />} />
          <Route path="nomenclature" element={<Nomenclature />} />
          <Route path="nomenclature/:id" element={<NomenclatureDetail />} />
          <Route path="sync-runs" element={<SyncRuns />} />
          <Route path="users" element={<Users />} />
          <Route path="documents" element={<DocumentCreate />} />
          <Route path="documents/history" element={<DocumentHistory />} />
          <Route path="documents/history/:id" element={<DocumentHistoryDetail />} />
          <Route path="documents/mappings" element={<StoreMappings />} />
          <Route path="documents/reference" element={<ReferenceData />} />
          <Route path="catalog-validation" element={<CatalogValidation />} />
          <Route path="api-tokens" element={<ApiTokens />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  )
}
